import { Outlet } from 'react-router'
import { LayoutWrapper } from 'core/components/layout/LayoutWrapper'
import React from 'react'

export const Layout: React.FC<{
  itemsCenter?: boolean
}> = ({ itemsCenter = false }) => {
  return (
    <LayoutWrapper layoutClassName="layout-container">
      <div className={`outlet-container ${itemsCenter ? 'items-center' : ''}`}>
        <Outlet />
      </div>
    </LayoutWrapper>
  )
}
